const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://weather-backend-879484113802.us-central1.run.app/api';

export interface LocationWeatherPatterns {
  location: string;
  coordinates: { lat: number; lng: number };
  nearestStation: {
    name: string;
    distance: number;
  };
  todayTypical: {
    averageHigh: number;
    averageLow: number;
    typicalConditions: string;
    rainChance: number;
  };
  weekPattern: Array<{
    date: string;
    averageHigh: number;
    averageLow: number;
    rainChance: number;
  }>;
  yearRoundSummary: string;
}

export interface CurrentDayTypical {
  location: string;
  date: string;
  historical: {
    averageHigh: number;
    averageLow: number;
    recordHigh: number;
    recordLow: number;
    typicalConditions: string;
    rainChance: number;
  };
  weekContext: Array<{
    date: string;
    dayOffset: number;
    averageHigh: number;
    averageLow: number;
    rainChance: number;
  }>;
  insights: string[];
}

class MyLocationApiService {
  async getWeatherPatterns(latitude: number, longitude: number): Promise<{ success: boolean; data: LocationWeatherPatterns }> {
    const response = await fetch(`${API_BASE_URL}/my-location/weather-patterns`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ latitude, longitude }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async getCurrentDayTypical(
    latitude: number, 
    longitude: number, 
    date?: string
  ): Promise<{ success: boolean; data: CurrentDayTypical }> {
    const response = await fetch(`${API_BASE_URL}/my-location/current-day-typical`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ latitude, longitude, date }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return response.json();
  }
}

export const myLocationApi = new MyLocationApiService();
